import type { TextFieldProps } from '@material-ui/core';
import React from 'react';
import { ErrorMessage, Field, useFormikContext } from 'formik';
import InputMask from 'react-input-mask';
import Input from 'components/Form/Input';
import { Error } from 'components/Form/Input/styles';

type FormikTextFieldProps = {
  mask: string | (string | RegExp)[];
  Component: any;
  disabled: boolean;
  ComponentProps: {
    name: string;
    label: string;
    placeholder: string;
    as: any;
  };
  defaultValue?: string;
} & TextFieldProps;

const MaskedInput: React.FC<FormikTextFieldProps> = ({
  mask,
  Component,
  ComponentProps,
  disabled,
  defaultValue,
}) => {
  const { setFieldValue } = useFormikContext();
  const [value, setValue] = React.useState(defaultValue);

  React.useEffect(() => {
    setValue(defaultValue || '');
  }, [defaultValue]);

  return (
    <>
      <Field
        name={ComponentProps.name}
        as={Input}
        render={() => {
          return (
            <InputMask
              mask={mask}
              disabled={disabled ?? false}
              name={`${ComponentProps.name}_masked`}
              value={value}
              onChange={(e: any) => {
                const changedValue = (e.target.value || '')
                  .replace(/\)/g, '')
                  .replace(/\(/g, '')
                  .replace(/-/g, '')
                  .replace(/ /g, '')
                  .replace(/_/g, '');
                setValue(changedValue);
                setFieldValue(ComponentProps.name, changedValue);
              }}
            >
              <Component {...ComponentProps} />
            </InputMask>
          );
        }}
      />
      <ErrorMessage component={Error} name={ComponentProps.name} />
    </>
  );
};

MaskedInput.defaultProps = {
  defaultValue: '',
};

export default MaskedInput;
